// DividerBlock + SpacerBlock — atomic layout primitives. No props beyond
// the universal ones. Two files? Same file: they're trivially related and
// always paired conceptually.

import type { BlockUniversalProps } from "./types";

export function DividerBlock({ themeVariant, className }: BlockUniversalProps) {
  return (
    <hr
      className={"sd-block-divider" + (className ? " " + className : "")}
      data-variant={themeVariant}
    />
  );
}

/** Editorial separator. Visually similar to a divider but the editorial-
 *  glass scope gives it its own breathing room (24px margin top/bottom) so
 *  it reads as a section break, not an inline rule. */
export function LineBlock({ themeVariant, className }: BlockUniversalProps) {
  return (
    <hr
      className={"sd-block-line" + (className ? " " + className : "")}
      data-variant={themeVariant}
    />
  );
}

export interface SpacerBlockProps extends BlockUniversalProps {
  size?: "sm" | "md" | "lg";
}

export function SpacerBlock({ size = "md", themeVariant, className }: SpacerBlockProps) {
  return (
    <div
      className={"sd-block-spacer sd-block-spacer--" + size + (className ? " " + className : "")}
      data-variant={themeVariant}
      aria-hidden="true"
    />
  );
}
